<template>
  <div class="animated fadeInRight ecommerce">
    <el-row>
      <el-col :span="24">
        <el-card class="">
          <div slot="header" class="flex justify-between">
            <span>{{ $t('serviceImplManage.queryCondition') }}</span>
            <div class="card-header-right">
              <el-button type="text" @click="_moreCondition()">
                {{ serviceImplManageInfo.moreCondition ? $t('common.hide') : $t('common.more') }}
              </el-button>
            </div>
          </div>
          <div class="card-body">
            <el-form :inline="true" :model="serviceImplManageInfo.conditions" class="flex justify-start">
              <el-form-item>
                <el-form-item>
                  <el-input v-model="serviceImplManageInfo.conditions.businessTypeCd"
                    :placeholder="$t('serviceImplManage.enterBusinessType')">
                  </el-input>
                </el-form-item>
              </el-form-item>
              <el-form-item>
                <el-form-item>
                  <el-input v-model="serviceImplManageInfo.conditions.name"
                    :placeholder="$t('serviceImplManage.enterBusinessName')">
                  </el-input>
                </el-form-item>
              </el-form-item>
              <el-form-item>
                <el-form-item>
                  <el-select v-model="serviceImplManageInfo.conditions.invokeType" style="width:100%"
                    :placeholder="$t('serviceImplManage.selectInvokeType')">
                    <el-option :value="''" :label="$t('serviceImplManage.selectInvokeType')"></el-option>
                    <el-option value="1" :label="$t('serviceImplManage.microservicePost')"></el-option>
                    <el-option value="2" :label="$t('serviceImplManage.webservice')"></el-option>
                    <el-option value="3" :label="$t('serviceImplManage.httpPost')"></el-option>
                  </el-select>
                </el-form-item>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="_queryServiceImplMethod()">
                  <i class="el-icon-search"></i>
                  {{ $t('common.query') }}
                </el-button>
                <el-button @click="_resetServiceImplMethod()">
                  <i class="el-icon-refresh"></i>
                  {{ $t('common.reset') }}
                </el-button>
              </el-form-item>
            </el-form>
            <el-form :inline="true" :model="serviceImplManageInfo.conditions" class="flex justify-start"
              v-if="serviceImplManageInfo.moreCondition">
              <el-form-item>
                <el-form-item>
                  <el-input v-model="serviceImplManageInfo.conditions.messageTopic"
                    :placeholder="$t('serviceImplManage.enterKafkaTopic')">
                  </el-input>
                </el-form-item>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
      </el-col>
    </el-row>


    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('serviceImplManage.serviceImplInfo') }}</span>
        <div class="card-header-right">
          <el-button type="primary" size="small" @click="_openAddServiceImplModal()">
            <i class="el-icon-plus"></i>
            {{ $t('common.add') }}
          </el-button>
        </div>
      </div>
      <div class="">
        <el-table :data="serviceImplManageInfo.serviceImpls" style="width: 100%" border>
          <el-table-column prop="serviceBusinessId" :label="$t('serviceImplManage.serviceImplId')" align="center">
          </el-table-column>
          <el-table-column prop="businessTypeCd" :label="$t('serviceImplManage.businessType')" align="center">
          </el-table-column>
          <el-table-column prop="name" :label="$t('serviceImplManage.businessName')" align="center">
          </el-table-column>
          <el-table-column prop="invokeType" :label="$t('serviceImplManage.invokeType')" align="center">
            <template slot-scope="scope">
              {{ scope.row.invokeType == '1' ? $t('serviceImplManage.microservicePost') :
                scope.row.invokeType == '2' ? $t('serviceImplManage.webservice') :
                  $t('serviceImplManage.httpPost') }}
            </template>
          </el-table-column>
          <el-table-column prop="messageTopic" :label="$t('serviceImplManage.kafkaTopic')" align="center">
          </el-table-column>
          <el-table-column :label="$t('common.operation')" align="center" width="200">
            <template slot-scope="scope">
              <el-button-group>
                <el-button size="mini" @click="_openEditServiceImplModel(scope.row)">
                  {{ $t('common.edit') }}
                </el-button>
                <el-button size="mini" type="danger" @click="_openDeleteServiceImplModel(scope.row)">
                  {{ $t('common.delete') }}
                </el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
          layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </el-card>


    <add-service-impl ref="addServiceImpl" @success="_listServiceImpls"></add-service-impl>
    <edit-service-impl ref="editServiceImpl" @success="_listServiceImpls"></edit-service-impl>
    <delete-service-impl ref="deleteServiceImpl" @success="_listServiceImpls"></delete-service-impl>
  </div>
</template>

<script>
import { listServiceImpls } from '@/api/dev/serviceImplApi'
import AddServiceImpl from '@/components/dev/addServiceImpl/addServiceImpl'
import EditServiceImpl from '@/components/dev/editServiceImpl/editServiceImpl'
import DeleteServiceImpl from '@/components/dev/deleteServiceImpl/deleteServiceImpl'

export default {
  name: 'ServiceImplManage',
  components: {
    AddServiceImpl,
    EditServiceImpl,
    DeleteServiceImpl
  },
  data() {
    return {
      serviceImplManageInfo: {
        serviceImpls: [],
        total: 0,
        moreCondition: false,
        conditions: {
          businessTypeCd: '',
          name: '',
          invokeType: '',
          messageTopic: ''
        }
      },
      currentPage: 1,
      pageSize: 10
    }
  },
  created() {
    this._listServiceImpls(this.currentPage, this.pageSize)
  },
  methods: {
    _listServiceImpls(page, rows) {
      const params = {
        ...this.serviceImplManageInfo.conditions,
        page,
        row: rows
      }

      listServiceImpls(params).then(res => {
        this.serviceImplManageInfo.serviceImpls = res.data
        this.serviceImplManageInfo.total = res.total
      }).catch(err => {
        console.error(err)
      })
    },
    _openAddServiceImplModal() {
      this.$refs.addServiceImpl.open()
    },
    _openEditServiceImplModel(serviceImpl) {
      this.$refs.editServiceImpl.open(serviceImpl)
    },
    _openDeleteServiceImplModel(serviceImpl) {
      this.$refs.deleteServiceImpl.open(serviceImpl)
    },
    _queryServiceImplMethod() {
      this.currentPage = 1
      this._listServiceImpls(this.currentPage, this.pageSize)
    },
    _resetServiceImplMethod() {
      this.serviceImplManageInfo.conditions = {
        businessTypeCd: '',
        name: '',
        invokeType: '',
        messageTopic: ''
      }
      this._listServiceImpls(this.currentPage, this.pageSize)
    },
    _moreCondition() {
      this.serviceImplManageInfo.moreCondition = !this.serviceImplManageInfo.moreCondition
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._listServiceImpls(this.currentPage, this.pageSize)
    }
  }
}
</script>

<style scoped>
.card-header-right {
  float: right;
  margin-top: -5px;
}
</style>